const KEY_PREFIX = 'post_draft_';

function keyFor(userId: number, formId: string) {
  return `${KEY_PREFIX}${userId}_${formId}`;
}

export function savePostDraft(userId: number, formId: string, text: string) {
  try {
    if (text) {
      localStorage.setItem(keyFor(userId, formId), text);
    } else {
      localStorage.removeItem(keyFor(userId, formId));
    }
  } catch {}
}

export function getPostDraft(userId: number, formId: string): string {
  try {
    return localStorage.getItem(keyFor(userId, formId)) || '';
  } catch {
    return '';
  }
}

export function removePostDraft(userId: number, formId: string) {
  try {
    localStorage.removeItem(keyFor(userId, formId));
  } catch {}
}
